export default __webpack_public_path__ + "static/media/third-right-img@1x.267947f6.webp";